import React from 'react';
import { withRouter } from 'react-router';

import styles from './TextPage.scss';

class TextPage extends React.Component {
  constructor(props) {
    super(props);

    this.navigateToLink = this.navigateToLink.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.navigateToLink, false);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.navigateToLink);
  }

  // All of the HTML is rendered from Markdown, but we don’t want to refresh
  // the page everytime someone clicks an internal link.
  navigateToLink(event) {
    const { tagName, attributes } = event.target;
    const href = attributes[0];
    if (
      tagName === 'A' &&
      href &&
      href.name === 'href' &&
      href.value.match(/^\//)
    ) {
      event.preventDefault();
      this.props.history.push(href.value);
    }
  }

  render() {
    const { html } = this.props;

    return (
      <div className="TextPage">
        <div
          className="TextPage__container"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    );
  }
}

export default withRouter(TextPage);
